module.exports = __webpack_public_path__ + "img/profile-picture-big.c6a9b47c.jpg";